/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Breadcrumb, BreadcrumbItem, Button, Container, Input, InputGroup, InputGroupText } from 'reactstrap'
import { topPlaces } from '../../services/auth.service'
import './Ads.scss';
import GridView from './GridView';
import TableView from '../Category/Cemetery/TableView';
import { IoIosSearch } from 'react-icons/io';
import SelectRouteModal from '../../components/Modals/SelectRouteModal';
import { toast } from 'react-toastify';
import { routeDetail, updateRouteDetail } from '../../services/myRoute.service';
import { useSelector } from 'react-redux';
import CreateNewAds from './CreateNewAds';
import { BsDisplay } from 'react-icons/bs';

const Ads = () => {
    const location = useLocation()
    const [adsData, setAdsData] = useState()
    const [viewName, setViewname] = useState('grid');
    const [mapView, setMapView] = useState(false)
    const [route, setRoute] = useState(null);
    const [mkmID, setMkmId] = useState();
    const [showModal, setShowModal] = useState(false);
    const [activeMarker, setActiveMarker] = useState(null);
    const [pointName, setPointName] = useState(null);
    const [showCreateModal, setShowCreateModal] = useState(false)


    let { categoryName } = location?.state || '';

    const userName = useSelector((state) => state?.userDetailReducer?.userData?.userName);

    // useEffect(() => {
    //     topPlaces().then((data) => setAdsData(data.data))
    // }, [])

    // const handleChange = (e) => {
    // 	const newData = { ...values };
    // 	newData[e?.target?.id] = e?.target?.value?.replace(/^\s+/, '').replace(regex, '');
    // 	setValues(newData);
    // 	debounce(() => setDebouceValue(newData));
    // }

    const handleClick = (view) => {
		// dispatch(changeView(view))
		setViewname(view);
		setMapView(false)
	}

    // const handleClickMapView = (view) => {
	// 	// dispatch(changeView(view))
	// 	setViewname(view);
	// 	setMapView(true)
	// }

    const toggle = () => {
        setShowModal(!showModal);
    };

    const createNewRoute = () => {
        setShowModal(false);
        // setShowCreateRouteModal(true);
    };

    const createToogle = () =>{
        setShowCreateModal(!showCreateModal)
    }

    const addToRoute = (id, name) => {
        console.log("place to add.........", id);
        setMkmId(id);
        setPointName(name);
        console.log("pointName", pointName);
        setShowModal(true);
      };

    const selectRoute = async () => {
        let existingData;
        if (route?.id) {
            try {
                let response = await routeDetail({
                    userName: userName,
                    routeID: route?.id
                });
                if (response && response?.status === 200) {
                    existingData = response?.data?.data;
                }

                let requestBody = [];
                if (existingData?.length < 25) {
                    if (existingData?.length === 0) {
                        requestBody?.push({
                            mkmID: mkmID,
                            orderNumber: 0,
                            visited: false
                        });
                    } else if (existingData?.length === 1) {
                        requestBody?.push({
                            mkmID: existingData[0]?.place?.mkmID,
                            orderNumber: 0,
                            visited: false
                        });
                        requestBody?.push({
                            mkmID: mkmID,
                            orderNumber: 1,
                            visited: false
                        })
                    } else {
                        existingData?.splice(existingData?.length, 0, {
                            mkmID: mkmID,
                            orderNumber: existingData?.length,
                            visited: false
                        });
                        requestBody = existingData?.map((item, i) => {
                            return {
                                mkmID: item?.place?.mkmID || item?.mkmID,
                                orderNumber: i,
                                visited: item?.visited
                            }
                        });
                    }
                    try {
                        let res = await updateRouteDetail(requestBody, {
                            userName: userName,
                            routeID: route?.id,
                        });
                        if (res && res?.status === 200) {
                            setActiveMarker(null)
                            toast.success("Point Added Successfully In Your Route!", {
                                position: toast.POSITION.TOP_RIGHT,
                                autoClose: 2000
                            })
                        }
                    } catch (err) {
                        toast.error(
                            err?.response?.data?.message ||
                            "Oops.. something went wrong, try again !!!",
                            {
                                position: toast.POSITION.TOP_RIGHT,
                                autoClose: 2000,
                            }
                        );
                    }
                    setRoute('');
                    setShowModal(false);
                }
                else {
                    toast.warning("Max of only 25 credits can be added to a route, Kindly remove a point to add a new point.", {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 2000
                    })
                }
                setRoute('');
                setShowModal(false);
            } catch (error) {
                console.log(error);
            };
        }
        if (!route?.id) {
            toast.error("Please Select The Route.", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 2000
            })
        }
    }






    return (
        <div className="main_section ads">
            <Container>
            <div className='breadcrumb_section'>
                <Container >
                    <Breadcrumb className="breadcrumb">
                        <BreadcrumbItem>
                            <Link to="/" className="breadcrumb_item1">Home</Link>
                        </BreadcrumbItem>
                        <BreadcrumbItem active><Link to="/ads" className="breadcrumb_item2">Ads</Link></BreadcrumbItem>
                    </Breadcrumb>
                </Container>
            </div>
            <div className="myroutes_section">
                <Container fluid>
                    <div className="myroutes_box">
                        <div className="myroutes_box_header">
                            {/* <h4>{categoryName + '/' + categoryTitle}</h4> */}
                            <div className="search_input">
                                <InputGroup size="sm">
                                    <InputGroupText style={{ backgroundColor: "#FFFFFF" }}>
                                        <IoIosSearch size={25} />
                                    </InputGroupText>
                                    <Input
                                        type='search'
                                        id='search'
                                        name='search'
                                        // value={values?.search}
                                        // onChange={handleChange}
                                        maxLength="100"
                                        // placeholder={`Search in ${categoryName}`}
                                        autoComplete='off'
                                    />
                                </InputGroup>
                            </div>
                        </div>
                        <div>
                        </div>
                        <div className="myroutes_block">
                            <div className="button_section">
                                <div className="view_btn">
                            <Button className='grid active' name='Create new ads' onClick={()=>setShowCreateModal(true)}>Create new Ads</Button>

                                    {/* <Button
                                        name="grid" className={viewName === 'grid' ? "active" : ""}
                                        onClick={() => handleClick('grid')}>
                                        Grid View
                                    </Button>
                                    <Button
                                        name="table" className={viewName === 'table' ? "active" : ""}
                                        onClick={() => handleClick('table')}>
                                        Table View
                                    </Button> */}
                                </div>
                            </div>
                                    <GridView
                                        data={adsData}
                                        addToRoute={addToRoute}
                                    />
                                                                  </div>
                    </div>
                    <SelectRouteModal
                        route={route}
                        setRoute={setRoute}
                        showModal={showModal}
                        toggle={toggle}
                        createNewRoute={createNewRoute}
                        selectRoute={selectRoute}
                    />
                    <CreateNewAds showModal={showCreateModal} toggle={createToogle}  />
                </Container>
            </div>
            
            </Container>
        </div>
    )
}

export default Ads
